import React, { useState, useRef } from 'react';
import { Carousel, Button } from 'antd';
import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import defaultPreviewPlaceholder from '../../Assets/dummy_images/default-preview-placeholder.webp';

const PrevArrow = ({ onClick }) => (
  <Button
    shape="circle"
    icon={<LeftOutlined />}
    onClick={onClick}
    className="absolute left-2 top-1/2 z-10 -translate-y-1/2 bg-white/70 hover:bg-white"
  />
);

const NextArrow = ({ onClick }) => (
  <Button
    shape="circle"
    icon={<RightOutlined />}
    onClick={onClick}
    className="absolute right-2 top-1/2 z-10 -translate-y-1/2 bg-white/70 hover:bg-white"
  />
);

export default function FacebookModal({ Previewimages: mediaItems = [], Previewcaptions = '', profile }) {
  const [open, setOpen] = useState(true);
  const carouselRef = useRef();

  const renderMedia = () => {
    if (!mediaItems || mediaItems.length === 0) {
      return (
        <img
          src={defaultPreviewPlaceholder}
          alt="Default preview"
          className="w-full h-auto max-h-96 object-cover"
        />
      );
    }

    const renderSingleItem = (item) => {
      const urlToRender = item.permanentUrl || item.localUrl;
      return item.type === 'video'
        ? (
          <video
            src={urlToRender}
            controls
            className="w-full h-auto max-h-96 object-contain bg-black"
          />
        )
        : (
          <img
            src={urlToRender}
            className="w-full h-auto max-h-96 object-cover"
            alt="Post preview"
          />
        );
    };

    if (mediaItems.length === 1) {
      return renderSingleItem(mediaItems[0]);
    }

    return (
      <Carousel ref={carouselRef} arrows prevArrow={<PrevArrow />} nextArrow={<NextArrow />}>
        {mediaItems.map((item, index) => (
          <div key={index}>
            {renderSingleItem(item)}
          </div>
        ))}
      </Carousel>
    );
  };

  return (
    <div className="w-full max-w-md mx-auto my-4 border border-gray-300 rounded-xl">
      <button
        onClick={() => setOpen(!open)}
        className="w-full flex items-center justify-between p-3 font-semibold text-left"
      >
        <div className="flex items-center gap-2">
          <i className="fa-brands fa-facebook text-blue-600 text-lg"></i>
          <span>Facebook</span>
        </div>
        <i className={`fa ${open ? "fa-angle-up" : "fa-angle-down"} text-gray-400`}></i>
      </button>

      {open && (
        <div className="border-t border-gray-200">
          <header className="flex items-center p-3 gap-3">
            {profile ? (
              <img
                src={`https://graph.facebook.com/${profile.platform_pageId}/picture?type=normal`}
                className="w-10 h-10 rounded-full"
                alt="profile"
              />
            ) : (
              <img
                src={defaultPreviewPlaceholder}
                alt="Default profile"
                className="w-10 h-10 rounded-full object-cover"
              />
            )}
            <div>
              <div className="font-semibold text-sm">
                {profile?.profile || "Facebook Page"}
              </div>
              <div className="text-xs text-gray-500">
                Just now · <i className="fa-solid fa-earth-americas"></i>
              </div>
            </div>
          </header>

          <div className="px-3 pb-2 text-sm whitespace-pre-wrap">
            {Previewcaptions || (
              <span className="text-gray-400 italic">The main caption will appear here...</span>
            )}
          </div>

          <div className="relative bg-black">
            {renderMedia()}
          </div>

          <footer className="flex justify-around items-center p-1 border-t text-gray-600 font-semibold text-sm">
            <button className="flex-1 p-2 rounded-lg hover:bg-gray-100 flex items-center justify-center gap-2">
              <i className="fa-regular fa-thumbs-up"></i>Like
            </button>
            <button className="flex-1 p-2 rounded-lg hover:bg-gray-100 flex items-center justify-center gap-2">
              <i className="fa-regular fa-comment"></i>Comment
            </button>
            <button className="flex-1 p-2 rounded-lg hover:bg-gray-100 flex items-center justify-center gap-2">
              <i className="fa-solid fa-share"></i>Share
            </button>
          </footer>
        </div>
      )}
    </div>
  );
}